import localforage from 'localforage';
import FJFontManager from './FJFontManager';
import FJUtil from '../../util/FJUtil.js';

class FJFontArrayBufferManager {
    /**
     * @desc font的数据 {filePath: '', fontName1: {}, fontName2: {}}
     */
    _fontNameData = null;
    loadFontNameData = data => {
        this._fontNameData = data;
    };

    hasFontNameData = () => {
        return !!this._fontNameData;
    };

    _getFontFetchPath = fontData => {
        let { fontName, bold, italic, fontPath } = fontData;
        let name = 'montserrat-regular.woff';
        if (!fontPath) {
            fontPath =
                'https://resource.flexclip.com/app/resource/font/fonts/' +
                fontName.toLowerCase().replace(/\s+/g, '-') +
                '/' +
                name;
        }
        return fontPath;
    };

    createFontArrayBuffer = async fontData => {
        try {
            const fontPath = this._getFontFetchPath(fontData);
            const res = await fetch(fontPath);
            const buffer = await res.arrayBuffer();
            if (!buffer?.byteLength) {
                throw new Error('No valid fontArrayBuffer');
            }

            try {
                // buffer 在使用 worker 解码时需要传递到 worker 线程，所以需要复制一份进行本地存储
                await localforage.setItem(FJUtil.hashValue(`${fontPath}`), buffer.slice(0));
            } catch (e) {
                console.log(e);
            }

            return buffer;
        } catch (e) {
            console.log(e);
            return null;
        }
    };

    getFontArrayBuffer = async fontData => {
        try {
            const fontFetchPath = this._getFontFetchPath(fontData);
            const arrayBuffer = await localforage.getItem(FJUtil.hashValue(`${fontFetchPath}`));
            if (!arrayBuffer?.byteLength) {
                return null;
            }
            return arrayBuffer;
        } catch (e) {
            console.log(e);
            return null;
        }
    };
    _getRealFontName = (fontName, bold, italic) => {
        let name = '';
        if (this._fontNameData) {
            let fontNameData = this._fontNameData[fontName.toLowerCase()];
            if (fontNameData) {
                let fontNameN7 = fontNameData.n7;
                let fontNameI4 = fontNameData.i4;
                let fontNameI7 = fontNameData.i7;
                let blobPlaceholder = bold && (fontNameI7 || fontNameN7) ? '7' : '4';
                let italicPlaceholder = italic && (fontNameI4 || fontNameI7) ? 'i' : 'n';
                name = fontNameData[`${italicPlaceholder}${blobPlaceholder}`];
            }
        }
        return name;
    };
}
let _instance = new FJFontArrayBufferManager();
export default _instance;
